import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// import '@/permission'

// 引入注册 piain
import pinia from '@/pinia/index'

createApp(App).use(router).use(pinia).use(ElementPlus).mount('#app')
